import { IconCircleInfoOutline18 as Info } from "nucleo-ui-outline-18"

import {
	ROUTINE_CAPABILITIES,
	ROUTINE_LIMITS_SENTENCE,
} from "./routine-capabilities"

export function RoutineCapabilitiesPopover() {
	return (
		<div className="flex flex-col gap-3">
			<div>
				<p className="text-[13px] font-medium text-primary">What it can do</p>
				<p className="mt-0.5 text-[12px] leading-relaxed text-tertiary">
					Six actions, all of them on the thread it just read.
				</p>
			</div>
			<div className="flex flex-col gap-2.5">
				{ROUTINE_CAPABILITIES.map(({ Icon, label, detail }) => (
					<div key={label} className="flex items-start gap-2.5">
						<Icon className="mt-px h-[15px] w-[15px] flex-none text-secondary" />
						<span className="min-w-0">
							<span className="block text-[12.5px] font-medium text-primary">
								{label}
							</span>
							<span className="block text-[12px] leading-relaxed text-tertiary">
								{detail}
							</span>
						</span>
					</div>
				))}
			</div>
		</div>
	)
}

// Stays on screen once the routine is live, which is where the limits matter.
export function RoutineLimitsRow() {
	return (
		<div className="flex items-center gap-2">
			<Info className="h-[14px] w-[14px] flex-none text-tertiary" />
			<p className="text-[12px] leading-relaxed text-tertiary">
				{ROUTINE_LIMITS_SENTENCE}
			</p>
		</div>
	)
}
